import { ReactNode } from 'react'
import { SubTask } from '../../../../page_components/PoolDetails/Missions/types'
import ImageVerificationPage from './Page'

export type Props = {
  taskId: number
  subtask: SubTask
  onClose: () => void
  updateTaskSubmissions: () => Promise<unknown>
  taskAmount: ReactNode
}

export type ButtonProps = {
  disabled?: boolean
}

const ImageVerificationTask = ({
  taskId,
  subtask,
  onClose,
  updateTaskSubmissions,
  taskAmount,
}: Props) => {
  if (!subtask) return <></>
  const { imageVerification } = subtask
  if (!imageVerification) return <></>

  const stringValueRef: {
    [key: string]: string
  } = {
    instagram_verification: 'Instagram',
    tiktok_verification: 'TikTok',
    youtube_verification: 'YouTube',
    spotify_verification: 'Spotify',
  }

  const verificationString = stringValueRef[imageVerification]

  if (!verificationString) return <></>

  return (
    <ImageVerificationPage
      subtask={subtask}
      taskId={taskId}
      onClose={onClose}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={taskAmount}
    />
  )
}

export default ImageVerificationTask
